import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Button,
  TextField,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Divider,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TablePagination
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { connect, useSelector } from 'react-redux';
import HttpService from '../services/httpService';
import { setLoading, setSnackInfo } from '../redux/actions/appAction';
import moment from 'moment';



const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(4),
    // backgroundColor: '#000000',
    minHeight: '100vh',
  },
  title: {
    fontWeight: 700,
    color: '#1e293b',
    marginBottom: theme.spacing(5),
    textAlign: 'center',
  },
  paperSection: {
    padding: theme.spacing(4),
    marginBottom: theme.spacing(6),
    borderRadius: '12px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
  },
  sectionTitle: {
    fontWeight: 'bold',
    marginBottom: theme.spacing(3),
    color: '#1a237e',
  },
  tableHeadCell: {
    backgroundColor: '#F47E46',
    color: 'white',
    fontWeight: 'bold',
    fontSize: '16px',
    textAlign: 'center',
  },
  tableBodyCell: {
    fontSize: '15px',
    fontWeight: 'bold',
    textAlign: 'center',
    padding: '16px',
    color: '#263238',
  },
  tableRowEven: {
    backgroundColor: '#ffffff',
  },
  tableRowOdd: {
    backgroundColor: '#f0f4f8',
  },
  dateInput: {
    marginTop: theme.spacing(1),
    backgroundColor: 'white',
    borderRadius: theme.shape.borderRadius,
    cursor: 'pointer',
    '& input': {
      padding: theme.spacing(1.5),
      fontSize: '16px',
      color: '#1a237e', 
    },
  },
  cancelButton: {
    backgroundColor: '#EF3F32 !important',
    color: 'white !important',
    borderRadius: '5px !important', 
    // '&:hover': {
    //   backgroundColor: '#f28b82 !important',
    // },
  },
  submitButton: {
    backgroundColor: '#355025 !important',
    color: 'white !important',
    borderRadius: '5px !important',
    // '&:hover': {
    //   backgroundColor: '#E0663D !important',
    // },
  },
  divider: {
    margin: `${theme.spacing(4)}px 0`,
  },
  logsTitle: {
    color: '#1b5e20',
    fontWeight: 'bold',
    marginBottom: theme.spacing(3),
  },

  statusWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
  },

blinkingDot: {
  height: '10px',
  width: '10px',
  borderRadius: '50%',
  animation: '$blinker 1s linear infinite',
},

greenDot: {
  backgroundColor: '#4CAF50',
},

redDot: {
  backgroundColor: '#f44336',
},

'@keyframes blinker': {
  '50%': {
    opacity: 0,
  },
},

submitButtonEnabled: {
  backgroundColor: '#355025 !important',
  color: 'white !important',
  borderRadius: '5px !important',
},

submitButtonDisabled: {
  backgroundColor: '#5a5a5a !important',
  color: 'white !important',
  borderRadius: '5px !important',
},


}));

const InwardingLockDate = (props) => {
    const classes = useStyles();
    const { userDetails } = useSelector(state => state.user)
    const [newDate, setNewDate] = useState('');
    const [dialogOpen, setDialogOpen] = useState(false);
    const [remarks, setRemarks] = useState('');
    const today = new Date().toISOString().split('T')[0];
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [allLockInwardingDate, setAllLockInwardingDate] = useState([]);




    useEffect(() => {
      allLockInwardingDateLogs();
    }, []); 

    
    // this is all Lock Inwarding Date Logs.
    const allLockInwardingDateLogs = async () => {
      try {
        let response = await HttpService.inwardingLockDateGet();
        const logs = response?.data?.data || [];
        setAllLockInwardingDate(logs);
      } catch (error) {
        console.log(error, "error");
        setAllLockInwardingDate([]);
      }
    };

    // this is post request for Lock Inwarding Date.
    const postLockInwardingDate = async () => {
      props.setLoading(true);
      try {   
        const payload = {
          inwardingCurrentLockDate: newDate,
          inwardingLockStatus: 'Current Locked',
          inwardingLockRemarks: remarks,
          userName: userDetails?.name,
        };
        const res = await HttpService.inwardingLockNewDateUpdate(payload);
        if (res?.status === 201) {
          props.setSnackInfo("Inwarding lock date updated successfully", "success");
        }
        setNewDate('');
        setRemarks('');
        setDialogOpen(false);
        allLockInwardingDateLogs(); // Refresh the logs after submission
      } catch (error) {
        console.error("Error posting inwarding lock date:", error);
        props.setSnackInfo("Something went wrong", "error");
      }
      props.setLoading(false);
    };


    const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
    };


    const handleSubmit = () => {
        setDialogOpen(true); // Open the confirmation dialog
    };

    const handleConfirmSubmit = () => {
        postLockInwardingDate(); 
        setDialogOpen(false);
        setRemarks('');
    };

    const handleDialogCancel = () => {
        setDialogOpen(false);
        setRemarks('');
        setNewDate('');
    };

    const handleCancel = () => {
        setNewDate('');
    };

    return (
        <>
            <Box className={classes.root}>
                <Typography variant="h4" className={classes.title}>
                Inwarding Date Lock Management
                </Typography>

                {/* Section 1: Inwarding Lock Date */}
                <Paper className={classes.paperSection}>
                <Typography variant="h5" className={classes.sectionTitle}>
                    Select date
                </Typography>
                <Grid container spacing={3} alignItems="center">
                    <Grid item xs={12} sm={6}>
                    <TextField
                        type="date"
                        value={newDate}
                        onChange={(e) => setNewDate(e.target.value)}
                        fullWidth
                        className={classes.dateInput}
                        inputProps={{
                            max: today, // Prevent future date selection
                        }}
                    />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                        <Button
                            variant="contained"
                            fullWidth
                            onClick={handleCancel}
                            className={classes.cancelButton}
                        >
                            Cancel
                        </Button>
                        </Grid>
                        <Grid item xs={6}>
                        <Button
                          variant="contained"
                          fullWidth
                          onClick={handleSubmit}
                          disabled={!newDate}
                          className={newDate ? classes.submitButtonEnabled : classes.submitButtonDisabled}
                        >
                          Submit
                        </Button>
                        </Grid>
                    </Grid>
                    </Grid>
                </Grid>
                </Paper>

                <Divider className={classes.divider} />

                {/* Section 2: Previous Logs */}
                <Paper className={classes.paperSection}>
                <Typography variant="h5" className={classes.logsTitle}>
                    Previous Logs
                </Typography>

                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell className={classes.tableHeadCell}>Sl.No</TableCell>
                        <TableCell className={classes.tableHeadCell}>User Name</TableCell>
                        <TableCell className={classes.tableHeadCell}>Lock Date</TableCell>
                        <TableCell className={classes.tableHeadCell}>Locked On</TableCell>
                        <TableCell className={classes.tableHeadCell}>Status</TableCell>
                        <TableCell className={classes.tableHeadCell}>Remarks</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {[...allLockInwardingDate]
                        .slice(rowsPerPage > 0 ? page * rowsPerPage : 0, rowsPerPage > 0 ? page * rowsPerPage + rowsPerPage : allLockInwardingDate.length)
                        .map((log, index) => {
                          const isCurrent = log.inwardingLockStatus === 'Current Locked';
                          const rowNumber = page * rowsPerPage + index + 1;

                          return (
                            <TableRow
                              key={index}
                              style={{
                                backgroundColor: isCurrent ? '#d0f0c0' : '#ffcdd2',
                              }}
                            >
                              <TableCell className={classes.tableBodyCell}>{rowNumber}</TableCell> {/* Index cell */}
                              <TableCell className={classes.tableBodyCell}>{log.userName}</TableCell>
                              <TableCell className={classes.tableBodyCell}>
                                {moment(log.inwardingCurrentLockDate).format('DD/MM/YYYY')}
                              </TableCell>
                              <TableCell className={classes.tableBodyCell}>
                                {moment(log.createdAt).format('DD/MM/YYYY')}
                              </TableCell>
                              <TableCell className={classes.tableBodyCell}>
                                <div className={classes.statusWrapper}>
                                  <span className={`${classes.blinkingDot} ${isCurrent ? classes.greenDot : classes.redDot}`} />
                                  {log.inwardingLockStatus === 'Current Locked' ? 'Currently Locked' : 'Previously Locked'}
                                </div>
                              </TableCell>
                              <TableCell className={classes.tableBodyCell}>{log.inwardingLockRemarks}</TableCell>
                            </TableRow>
                          );
                        })}
                    </TableBody>
                  </Table>
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25, 50, 100, { label: 'All', value: -1 }]}
                    component="div"
                    count={allLockInwardingDate.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </TableContainer>
                </Paper>
            </Box>
            <Dialog open={dialogOpen} onClose={handleDialogCancel}>
                <DialogTitle>Confirm Submission</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                    Are you sure you want to lock the inwarding date to <b>{moment(newDate).format('DD/MM/YYYY')}</b>?
                    Please enter remarks before submitting.
                    </DialogContentText>
                    <TextField
                    autoFocus
                    margin="dense"
                    label="Remarks"
                    fullWidth
                    variant="outlined"
                    value={remarks}
                    onChange={(e) => setRemarks(e.target.value)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDialogCancel} color="secondary">
                    Cancel
                    </Button>
                    <Button
                    onClick={handleConfirmSubmit}
                    color="primary"
                    disabled={!remarks.trim()}
                    >
                    Confirm
                    </Button>
                </DialogActions>    
            </Dialog>
        </>

    );
};

export default connect(null, { setLoading, setSnackInfo })(InwardingLockDate);
